<template>
  <div
    class="accent w-full h-full d-flex align-center justify-center hover-pointer black--text"
    @click.stop="click"
  >
    <v-icon size="20"> mdi-alert-outline </v-icon>
    <div class="body-2 d-flex">
      <span class="font-weight-bold">This account is past due - </span>
      <div
        class="ml-1"
        v-html="message"
      />
    </div>
  </div>
</template>

<script>
import { DRAWERS } from '../../utils/constants';

export default {
  name: 'SubscriptionPastDueAlert',

  data() {
    return {};
  },

  computed: {
    message() {
      return '<span class="primary--text">click here</span> to update your payment and retry!';
    }
  },

  methods: {
    click() {
      // Open the CheckoutSubscriptionApp embed in retry-payment mode so the user can
      // add a new card (or pick a saved one) and pay the overdue invoice in place.
      // dispatch (not commit) so drawers/open routes it through <mcs-checkout-subscription>.
      this.$store.dispatch('drawers/open', {
        drawerId: DRAWERS.RETRY_PAYMENT_DRAWER,
        data: { source: 'dashboard_pastdue_banner' }
      });
    }
  }
};
</script>

<style></style>
